/* O Main.js resolve as páginas por import('../pages/' + menu.local), o que
   cria um context do webpack sobre src/pages/. Este index.js é o alvo desse
   import para local === "PortalResponsavel".

   Import + export explícitos em vez de `export { default } from …`: o
   ESLint do projeto (airbnb) barra reexportação de `default` com
   no-restricted-exports, e erro de ESLint quebra o build do CRA. Mesmo
   motivo documentado em pages/InteligenciaEducacional/index.js. */
import PortalResponsavel from "./PortalResponsavel";

export default PortalResponsavel;
